import { downloadBlob } from '@/utils/utils';
import { request } from '@umijs/max';
import { omit } from 'lodash';

// 查询账单信息
export async function getBillService(params: any) {
  return request(`/bcare/bill/detail`, {
    params,
    getResponse: true,
  });
}

// 查询账期信息
export async function getMonthService(params: any) {
  return request(`/bcare/bill/billingCycle`, {
    params,
  }).then((res) => {
    return res.acctCycleList || [];
  });
}

// 下载账单
export async function billDownloadService(params: any) {
  return request(`/bcare/bill/dms/downloadDoc`, {
    responseType: 'blob',
    params,
  }).then((res) => {
    downloadBlob(res, 'text/plain', params.fileName);
  });
}

// 查询支付类型
export async function getPaymentMothodService(params: any) {
  return request('/bcare/bill/payment/method', {
    method: 'POST',
    data: params,
  });
}

// 账单缴费
export async function billPaymentService(data: any) {
  return request('/bcare/webpay', {
    method: 'POST',
    data,
  });
}

export async function getPaymentResultService(params: any) {
  return request(`/bcare/webpay/result`, {
    params,
  });
}

export async function getBcareUserService(data: any) {
  const { conditionKey, ...restData } = data;
  return request(`/bcare/user/front/condition?${conditionKey}`, {
    method: 'POST',
    data: restData,
  });
}

// 检查账单是否已经缴费
export async function getPaymentService(data: any) {
  return request(`/bcare/webpay/payment`, {
    method: 'POST',
    data,
  });
}

export async function getunPaymentService(data: any) {
  return request(`/bcare/webpay/unPayment`, {
    method: 'POST',
    data,
  });
}

export async function getBankService(data: any) {
  return request(`/bcare/webpay/qryFpxBankList`, {
    method: 'POST',
    data,
  });
}

export async function getRePaymentService(data: any) {
  return request(`/bcare/webpay/rePayment`, {
    method: 'POST',
    data,
  });
}

export async function checkILockService(data: any) {
  return request(`/bcare/webpay/checkislock`, {
    method: 'POST',
    data,
  });
}

// um 查询信用卡列表
export async function getCreditCardService(data: any) {
  return request(`/bcare/bill/payment/method`, {
    method: 'POST',
    data,
  }).then((res) =>
    (res?.thirdPayChannelList || []).reduce(
      (acc: any, cur: any) => [
        ...acc,
        ...(cur?.thirdPayMethodDtoList || []).map((el: any) => ({
          ...el,
          ...omit(cur, 'thirdPayMethodDtoList'),
        })),
      ],
      [],
    ),
  );
}

// um查询支付收据
export async function getPaymentInfoService(params: any) {
  return request(`/bcare/webpay/paymentInfo`, {
    params,
  });
}
